// src/services/apiService.js

const API_BASE_URL = 'https://hostv7.visioner7.online/apiwebeventos/api/v1';

export const apiService = {
  // Listar categorías de galería
  async getCategorias() {
    try {
      const response = await fetch(`${API_BASE_URL}/galeria/categorias`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener categorías:', error);
      throw error;
    }
  },

  // Listar eventos
  async getEventos() {
    try {
      const response = await fetch(`${API_BASE_URL}/eventos`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener eventos:', error);
      throw error;
    }
  },

  // Obtener configuración del sitio
  async getConfiguracion() {
    try {
      const response = await fetch(`${API_BASE_URL}/sitio/configuracion`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener configuración:', error);
      throw error;
    }
  },

  // Obtener redes sociales
  async getRedesSociales() {
    try {
      const response = await fetch(`${API_BASE_URL}/sitio/redes`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener redes sociales:', error);
      throw error;
    }
  },


  // Obtener intro (video o imagen)
async getIntro() {
  try {
    const response = await fetch(`${API_BASE_URL}/sitio/intro`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`Error HTTP: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener intro:', error);
    throw error;
  }
},

// Obtener sliders
async getSliders() {
  try {
    const response = await fetch(`${API_BASE_URL}/sitio/slider`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`Error HTTP: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener sliders:', error);
    throw error;
  }
},


// Obtener marcas / aliados
async getMarcas() {
  try {
    const response = await fetch(`${API_BASE_URL}/sitio/marcas`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`Error HTTP: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener marcas:', error);
    throw error;
  }
},

 // Obtener equipos destacados
  async getEquiposDestacados(limit = 5) {
    try {
      const response = await fetch(`${API_BASE_URL}/equipos/destacados?limit=${limit}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('Error al obtener equipos destacados:', error);
      throw error;
    }
  },

  // Obtener detalle de un equipo por ID
  async getEquipoDetalle(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/equipos/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(`Error al obtener detalle del equipo ${id}:`, error);
      throw error;
    }
  },

  async getCategoriasEquipos() {
    try {
      const response = await fetch(`${API_BASE_URL}/equipos/categorias`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener categorías de equipos:', error);
      throw error;
    }
  },

  // Obtener equipos por categoría
async getEquiposPorCategoria(categoriaId, limit = 20) {
  try {
    // La API ya soporta el query param ?categoria=
    const response = await fetch(`${API_BASE_URL}/equipos?categoria=${categoriaId}&limit=${limit}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al obtener equipos por categoría:', error);
    throw error;
  }
},
// Obtener todos los equipos (Catálogo completo)
async getAllEquipos(limit = 24) {
  try {
    const response = await fetch(`${API_BASE_URL}/equipos?limit=${limit}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al obtener todos los equipos:', error);
    throw error;
  }
},
async getNosotros() {
  try {
    const response = await fetch(`${API_BASE_URL}/sitio/nosotros`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al obtener datos de nosotros:', error);
    throw error;
  }
}
,
// Obtener galería completa
async getGaleria() {
  try {
    const response = await fetch(`${API_BASE_URL}/galeria`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al obtener galería:', error);
    throw error;
  }
},

// Obtener categorías de galería (ya lo tienes, pero por si acaso)
async getCategoriasGaleria() {
  try {
    const response = await fetch(`${API_BASE_URL}/galeria/categorias`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al obtener categorías de galería:', error);
    throw error;
  }
},
// Obtener lista pública de eventos
async getEventos() {
  try {
    const response = await fetch(`${API_BASE_URL}/eventos`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al obtener eventos:', error);
    throw error;
  }
},

// Obtener detalle de un evento por slug
async getEventoDetalle(slug) {
  try {
    const response = await fetch(`${API_BASE_URL}/eventos/${slug}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error(`Error al obtener detalle del evento ${slug}:`, error);
    throw error;
  }
},

// Registrar nuevo contacto
async sendContactMessage(data) {
  try {
    const response = await fetch(`${API_BASE_URL}/contacto`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    
    if (!response.ok) {
      throw new Error(`Error HTTP: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error al enviar el mensaje de contacto:', error);
    throw error;
  }
}








};

export default apiService;